import { apiFetch } from './client'

export interface SystemUser {
  id: string
  email: string
  name: string
  role: 'superadmin' | 'admin' | 'recepcionista'
  active: boolean
  created_at: string
  last_login_at?: string | null
}

export interface CreateUserPayload {
  name: string
  email: string
  password: string
  role: 'admin' | 'recepcionista'
}

export interface UpdateUserPayload {
  name?: string
  email?: string
  password?: string
  role?: 'admin' | 'recepcionista'
}

export const listSystemUsers = () =>
  apiFetch<{ users: SystemUser[] }>('/system-users')

export const createSystemUser = (payload: CreateUserPayload) =>
  apiFetch<{ user: SystemUser }>('/system-users', { method: 'POST', body: JSON.stringify(payload) })

export const updateSystemUser = (id: string, payload: UpdateUserPayload) =>
  apiFetch<{ user: SystemUser }>(`/system-users/${id}`, { method: 'PATCH', body: JSON.stringify(payload) })

export const deactivateSystemUser = (id: string) =>
  apiFetch<{ success: boolean }>(`/system-users/${id}`, { method: 'DELETE' })
